import { track } from '@doordash/lib-tracking'
import { get } from 'lodash'
import i18n from '../i18n/'
import {
  getIsMobile,
  getMobileDevice,
  MobileDevice,
} from '../utilities/userAgent'
import { clientData, cookieData } from './commonData'

declare const window

const getCommonAttributes = state => {
  const email = get(state, 'application.email')
  const onboardingStep = get(state, 'onboardingStep') || undefined
  const country = get(state, 'signupCountryShortname')

  return { email, onboardingStep, country }
}
/**
 * A function that wraps our Redux instrumentation tracking to append common
 * event payload data to all tracking events.
 *
 * @param {string} name The name for the event.
 * @param {Function} f A function that generates the event payload data.
 * @param {Window} Window The window object. Defaults to window but can
 *   be overridden for testing.
 */
export const trackWithInfo = (
  name: string,
  f: (...args: any[]) => {} = () => ({}),
  Window = window
) => {
  const clientProps = {
    hasTouchEvents: Window.ontouchstart !== undefined,
    isMobile: getIsMobile(Window),
    innerWidth: Window.innerWidth,
    innerHeight: Window.innerHeight,
    location: Window.location,
    document: Window.document,
    navigator: Window.navigator,
    sha: get(Window, '__dd.sha'),
    currentLanguage: i18n.getCurrentLocale(),
  }
  const cookie = Window.document.cookie || ''
  const os = getMobileDevice()

  const contextCookieMap = {
    [MobileDevice.Android]: 'dd_device_id_ads',
    [MobileDevice.iOS]: 'dd_device_id_vendor',
    [MobileDevice.WindowsPhone]: null,
    [MobileDevice.Unknown]: null,
  }
  return track(name, state => {
    return {
      ...getCommonAttributes(state),
      ...f(state),
      context: {
        device: {
          id: getIsMobile
            ? get(cookieData(cookie), contextCookieMap[os])
            : null,
          type: getIsMobile() ? getMobileDevice() : null,
        },
      },
      _clientData: clientData(clientProps),
      _cookieData: cookieData(cookie),
    }
  })
}
